import React, { useState, useRef } from 'react';
import ReactDOM from 'react-dom'; // Import ReactDOM for createPortal
import './SerialNumberBadge.css';
import { RiEdit2Line } from "react-icons/ri"; 
import { useSelector } from 'react-redux'; 
import { selectUser } from '../../redux/features/auth/authSlice'; 

const SerialNumberBadge = ({ serialNumber, note, functionalStatus, onRemove, isRemovable = false, onEditData, onGoToUpdatePage }) => {
    const user = useSelector(selectUser); 
    const isUserAdmin = user?.permission === 'admin' || user?.permission === 'editor'; 
    const badgeRef = useRef(null); // Ref for the badge span
    const [tooltipStyle, setTooltipStyle] = useState({
        opacity: 0,
        visibility: 'hidden',
        top: '0px',
        left: '0px'
    });

    const handleMouseEnter = () => {
        if ((note || functionalStatus) && badgeRef.current) {
            const rect = badgeRef.current.getBoundingClientRect();
            // Position the tooltip above the badge
            // 'top' is set to the badge's top, CSS transform will move it above
            // 'left' is set to the badge's horizontal center, CSS transform will center it
            const topPos = rect.top; 
            const leftPos = rect.left + rect.width / 2;

            setTooltipStyle({
                top: `${topPos}px`,
                left: `${leftPos}px`,
                opacity: 1,
                visibility: 'visible',
            });
        }
    };

    const handleMouseLeave = () => {
        // Start fade out, CSS transition will handle the rest
        setTooltipStyle(prev => ({ ...prev, opacity: 0, visibility: 'hidden' }));
    };

    return (
        <>
            <span
                ref={badgeRef}
                className="serial-badge"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                {serialNumber}
            <div className="badge-actions"> {/* Container for action buttons */}
                {onEditData && (
                    <button
                        type="button"
                        onClick={onEditData}
                        className="badge-action-btn edit-note-btn" /* Updated class */
                        title="Edit data for this serial"
                    >
                        <RiEdit2Line size={14} />
                    </button>
                )}
                {onGoToUpdatePage && isUserAdmin &&(
                    <button
                        type="button"
                        onClick={onGoToUpdatePage}
                        className="badge-action-btn update-product-btn" /* New class */
                        title="Go to product update page to edit notes and other details"
                    >
                        <RiEdit2Line size={14} /> {/* Changed to icon */}
                    </button>
                )}
            </div>
            {onRemove && (
                <button
                    type="button"
                    onClick={(e) => { 
                        e.stopPropagation(); 
                        if (isRemovable && onRemove) onRemove(serialNumber); 
                    }}
                    className={`remove-serial-btn ${!isRemovable ? 'disabled' : ''}`}
                    disabled={!isRemovable}
                    title={isRemovable ? "Remove serial" : "Cannot remove - serial is in use"}
                >
                    ×
                </button>
            )}
            </span>
            {(note || functionalStatus) && ReactDOM.createPortal(
                <div className="custom-tooltip" style={tooltipStyle}>
                    {note && <div>{note}</div>}
                    {functionalStatus && <div style={{ marginTop: note ? '8px' : '0', fontWeight: 'bold' }}>Status: {functionalStatus}</div>}
                </div>,
                document.body // Render tooltip directly into document.body
            )}
        </>
    );
};

export default SerialNumberBadge;
